import { parseDate, sortDates } from "../../../utilities";
export const columnsForLogbookAdministrativeProceduresForPrint = [
  {
    Header: "Сист. №",
    accessor: "appNum",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Дата подачи заявления",
    accessor: "appDate",
    editable: false,
    show: true,
    viewType: "text",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header:
      "Фамилия, собственное имя, отчество гражданина или наименование юридического лица",
    accessor: "fioOrLeName",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header:
      "Место жительства (место пребывания) гражданина или место нахождения юридического лица, контактный телефон",
    accessor: "addressOrLeDocDepartmentAndPhone",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header:
      "Количество листов документов и (или) сведений, предствленных заинтересованным лицом",
    accessor: "appSheetCnt",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Дата повторного заявления",
    accessor: "dateOfRepeatStatement",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Наименование административной процедуры",
    accessor: "apName",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Исполнитель",
    accessor: "appUser",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Сроки исполнения",
    accessor: "srokIspolneniya",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header:
      "Отметка о направлении в соотвествующий уполномоченный орган и уведомлении об этом заинтересованного лица",
    accessor: "otmetkaONapravlenii",
    editable: true,
    typeEdit: "date",
    show: true,
    viewType: "text",
  },
  {
    Header: "Дата и результат принятого административного решения",
    accessor: "dateAndResultOfAp",
    editable: false,
    show: true,
    viewType: "text",
  },
  {
    Header: "Отметка об уведомлении заинтересованного лица о принятом решении",
    accessor: "otmetkaObUvelechenii",
    typeEdit: "date",
    editable: true,
    show: true,
    viewType: "text",
  },
  {
    Header: "Документ подшит в дело №, л",
    accessor: "docPodshitVDelo",
    typeEdit: "text",
    editable: true,
    show: true,
    viewType: "text",
  },
];
